import http from '@/plugins/axios_plugin';

class ServiceProdutos {

    listar() {
        return http.get('/api/produtos/listar')
    }

    filtrar(params) {
        return http.get('/api/produtos/listar', { params: params })
    }

    coresTamanhos() {
        return http.get('/api/corestamanhos')
    }

    coresTamanhos2(produto_id) {
        return http.get('/api/produtos/corestamanhos/' + produto_id)
    }

    excluir(produto_id) {
        return http.post('/api/produtos/' + produto_id + '/excluir')
    }

    salvar(produto) {
        return http.post('/api/produtos/salvar', produto)
    }

    editar(produto_id) {
        return http.get('/api/produtos/' + produto_id + '/editar')
    }

    atualizar(produto_id, produto) {
        return http.post('/api/produtos/' + produto_id + '/atualizar', produto)
    }

    carregarMidia(produto_id) {
        return http.get('/api/produtos/' + produto_id + '/midia');
    }

    salvarMidia(produto_id, midia) {
        return http.post('/api/produtos/' + produto_id + '/midia/salvar', midia);
    }

    listarCategorias() {
        return http.get('/api/produtos/categorias');
    }

    buscar(parametros) {
        let query = ''

        Object.keys(parametros).map(key => {
            if (query === "") {
                query = query + key + '=' + parametros[key]
            } else {
                query = query + "&" + key + '=' + parametros[key]
            }
        })

        if (query) query = '?' + query;

        return http.get('/api/produtos/buscar' + query);
    }

    grade(produto_id) {
        return http.get('/api/produtos/' + produto_id + '/grade');
    }

    homologacao(produto_id) {
        return http.get('/api/produtos/homologacao?produto_id=' + produto_id);
    }

    homologar(produto_id, status, erros) {
        let parametros = {
            status: status,
            erros: erros,
        };
        return http.post('/api/produtos/' + produto_id + '/homologar', parametros);
    }

    listarPossiveisErros() {
        return http.get('/api/produtos/possiveiserros');
    }

    buscarPorId(ids) {
        if (Array.isArray(ids)) {
            return http.get('/api/produtos/buscarid?id=' + ids.join(','));
        }
        return null;
    }

    renovarProdutoVencido(produto_id, resposta) {
        return http.post('/api/produtos/' + produto_id + '/renovar-vencido', { resposta: resposta })
    }

    ativar(produto_id) {
        return http.post('/api/produtos/' + produto_id + '/ativar');
    }

    desativar(produto_id) {
        return http.post('/api/produtos/' + produto_id + '/desativar');
    }

}

export default new ServiceProdutos();